export default __webpack_public_path__ + "static/MediaContentFive-f4db25fe01acedbc58a6a40556cdcb5f.webp";